import { request } from "@/interface/helper";

const str = "missionMedal";

export const missionMedal = {
  [`${str}`]: {
    getList: (data) => request({ data, method: "get", url: "/mission/medal/list" }),
    add: (data) => request({ data, method: "post", url: "/mission/medal/add" }),
    detail: (data) => request({ data, method: "post", url: "/mission/medal/detail" }),
    edit: (data) => request({ data, method: "post", url: "/mission/medal/modify" }),
  },
};
